import React from 'react';
import { withTranslation } from 'react-i18next';
import {
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from '@mui/material';

import { usePolicyState } from '@core/myta/components/PolicyModal';
import { useMytaverse } from '@providers/MytaverseProvider';
import { useClientSpecificProfileInformation } from '@hooks/clientSpecificUtils';
import {
  Header,
  ModalContainer,
} from '@core/dashboard/components/PopoverModal';
import { ProfileScreensEnum } from '../interfaces';
import AvatarBox from '@components/UserProfileModalNew/AvatarBox';

import { ReactComponent as EmailIcon } from '@public/images/email.svg';
import { ReactComponent as PrivacyIcon } from '@public/images/privacy.svg';
import { ReactComponent as LogoutIcon } from '@public/images/account_exit.svg';
import { ReactComponent as NextIcon } from '@public/images/next.svg';
import { ReactComponent as SettingsIcon } from '@public/images/settings.svg';

import { IMainMenuList } from './interfaces';
import { useStyles } from './styles';
import { AnalyticsType } from '@interfaces/analytics';

const MainScreen = ({
  onClose,
  setActiveScreen,
  onOpenLogoutModal,
  t: translate,
}: IMainMenuList) => {
  const classes = useStyles();

  const { user, trackAnalytics } = useMytaverse();
  const { profileUserName, profileEmail } =
    useClientSpecificProfileInformation();

  const { setOpen: setOpenPrivacy } = usePolicyState();

  return (
    <>
      <ModalContainer
        header={<Header onClose={onClose} />}
        isScrollable={false}
      >
        <AvatarBox
          avatar={user.profileImage?.url ?? ''}
          avatarFallback={user.name || profileEmail}
          name={profileUserName}
        />
        <MenuList sx={classes.menu}>
          <MenuItem sx={classes.link}>
            <ListItemIcon>
              <EmailIcon />
            </ListItemIcon>
            <ListItemText sx={classes.linkText}>{profileEmail}</ListItemText>
          </MenuItem>

          <MenuItem
            sx={classes.link}
            onClick={() => {
              setOpenPrivacy(true);
              trackAnalytics(AnalyticsType.ViewPrivacyPolicy, {
                ref: 'menu',
              });
              onClose();
            }}
          >
            <ListItemIcon>
              <PrivacyIcon />
            </ListItemIcon>
            <ListItemText sx={classes.linkText}>
              {translate('userProfile.privacy')}
            </ListItemText>
            <NextIcon />
          </MenuItem>

          <MenuItem
            sx={classes.link}
            onClick={() => setActiveScreen(ProfileScreensEnum.SETTINGS)}
          >
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText sx={classes.linkText}>
              {translate('userProfile.settings')}
            </ListItemText>
            <NextIcon />
          </MenuItem>

          <Divider />

          <MenuItem
            sx={classes.link}
            onClick={() => {
              onOpenLogoutModal();
              onClose();
            }}
          >
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText sx={classes.linkText}>
              {translate('userProfile.logOut')}
            </ListItemText>
          </MenuItem>
        </MenuList>
      </ModalContainer>
    </>
  );
};

export default withTranslation()(MainScreen);
